import React from 'react';
import { useNavigate } from 'react-router-dom';
import AccountDashboardController from "../Controllers/AccountDashboardController";
import LoadingSkeleton from "../../Components/LoadingSkeleton";

const AccountDashboardReportScreen = ({ selectedYear, netBalanceReport, netBalanceLoading, netBalanceError, totalExpenseData, totalExpenseLoading,
  totalExpenseError, disbursementReportData, disbursementReportLoading, disbursementReportError, expenseReportData, expenseReportLoading, expenseReportError,
  rejectionReportData, rejectionReportLoading, rejectionReportError }) => {
  const {
  } = AccountDashboardController();

  const navigate = useNavigate();

  const handleCardClick = (title, key, label, action_type) => {
    navigate("/status-list", {
      state: {
        title: title,
        report_key: key,
        heading: label,
        action_type: action_type,
        selectedYear: selectedYear,
      }
    });
  };

  const formatIndianCurrency = (value) => {
    if (typeof value !== 'number' || isNaN(value)) return "--";
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  const renderCard = (label, value) => {
    const isNetAmount = label === 'Net Amount Payable';
    const greenStyle = { color: '#609966', fontWeight: '600' };

    return (
      <div style={{ background: '#F7F8FA', padding: '20px 10px 5px 10px', borderRadius: '4px', flex: 'auto' }}>
        <div className="task-label-container">
          <p className="task-label" style={isNetAmount ? greenStyle : { color: '#505470' }}>{label}</p>
        </div>
        <h4
          className="task-count"
          style={{
            fontSize: '20px',
            fontWeight: '600',
            ...(isNetAmount ? greenStyle : {}),
          }}
        >
          {netBalanceLoading ? (
            <LoadingSkeleton width="60px" height="15px" />
          ) : (
            // typeof value === 'number' && !isNaN(value) ? value.toFixed(2) : "--"
            typeof value === 'number' && !isNaN(value) ? formatIndianCurrency(value) : "--"
          )}
        </h4>
      </div>
    );
  };

  const renderGroupCard = (title, dataArray, loading, error) => {
    const isStaticReport = title === 'Pending Expense and Disbursement Report' || title === 'Rejection Report';
    const isFormat = title === 'Pending Expense and Disbursement Report';

    return (
      <div style={{ flex: '0 1 calc(33% - 20px)' }}>
        <div style={{ ...styles.sectionCard }}>
          <h4 style={styles.sectionTitle}>{title}</h4>
          {dataArray.map((item, idx) => (
            <div key={idx} style={styles.sectionItem} className="nth-child-color">
              <p>{item?.label}</p>
              <span
                className={isStaticReport ? 'task-label' : ''}
                style={{
                  fontWeight: '500',
                  color: '#000',
                  ...(isStaticReport
                    ? {}
                    : {
                      ...styles.itemValue,
                      textDecoration: item?.value === '--' ? 'none' : 'underline',
                      cursor:
                        item?.value !== '--' && item?.value > 0
                          ? 'pointer'
                          : 'not-allowed',
                    }),
                }}
                onClick={() => {
                  if (
                    !isStaticReport &&
                    item?.value !== '--' &&
                    item?.value > 0
                  ) {
                    handleCardClick(title, item.key, item.label, item.action_type);
                  }
                }}
              >
                {loading ? (
                  <LoadingSkeleton width="50px" height="10px" />
                ) : typeof item?.value === 'number' && !isNaN(item?.value) ? (
                  // item?.value < 10 ? `0${item?.value}` : item?.value
                  item?.value < 10 ? `0${item?.value}` : isFormat ? formatIndianCurrency(item?.value) : item?.value
                ) : (
                  item?.value ?? '--'
                )}
              </span>
            </div>
          ))}
          {error && !loading && (
            <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ marginBottom: '30px' }}>
      <div className='tasksScreen-tasks-container'>
        <div className="title-container" style={{ paddingBottom: 10, justifyContent: 'flex-start', gap: '25px' }}>
          <h2 className='tab-componrnt-title'>Net Balance Report</h2>
        </div>

        <div>
          <div className="overview-content">
            {renderCard("Opening Balance", netBalanceReport?.opening_balance)}
            {renderCard("Disbursement Approved", netBalanceReport?.disbursement_approved)}
            {renderCard("Expense Approved", netBalanceReport?.expense_approved)}
            {renderCard("Net Amount Payable", netBalanceReport?.net_payable)}
          </div>
          {netBalanceError && !netBalanceLoading && (
            <p style={{ color: 'red', fontSize: '12px' }}>{netBalanceError}</p>
          )}
        </div>
      </div>
      <div style={{ display: 'flex', gap: '20px', marginTop: '20px', flexWrap: 'wrap' }}>
        {/* Left side - First Div */}
        <div style={{ flex: '1 1 33%', display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
          <div style={{ width: 'calc(50% - 10px)' }}>
            {renderGroupCard("Pending Expense and Disbursement Report", [
              { label: "Expense Pending for Approval", value: totalExpenseData?.pending_expense },
              { label: "Disbursements pending for approval", value: totalExpenseData?.pending_disburse }
            ], totalExpenseLoading, totalExpenseError)}
          </div>

          <div style={{ width: 'calc(50% - 10px)' }}>
            {renderGroupCard("Disbursement wise Reports", [
              { label: "Approved Disbursement", value: disbursementReportData?.approved, action_type: "approved_disbursement" },
              { label: "Pending Disbursement", value: disbursementReportData?.pending, action_type: "pending_disbursement" },
              { label: "Rejected Disbursement", value: disbursementReportData?.rejected, action_type: "rejected_disbursement" }
            ], disbursementReportLoading, disbursementReportError)}
          </div>

          <div style={{ width: 'calc(50% - 10px)' }}>
            {renderGroupCard("Rejection Report", [
              { label: "Expense Rejected Completely", value: rejectionReportData?.expense_rejected_completely },
              { label: "Expense Rejected Partially", value: rejectionReportData?.expense_rejected_partially },
              { label: "Disbursement Rejected", value: rejectionReportData?.disbursement_rejected }
            ], rejectionReportLoading, rejectionReportError)}
          </div>
        </div>

        {/* Right side - Second Div */}
        <div style={{ flex: 1 }}>
          {renderGroupCard("Expense wise Reports", [
            { label: "Approved Expenses", key: "approved_expenses", value: expenseReportData?.approved, action_type: "approved_expenses" },
            { label: "Pending Expenses", key: "pending_expenses", value: expenseReportData?.pending, action_type: "pending_expenses" },
            { label: "Rejected Partially", key: "rejected_partially", value: expenseReportData?.rejected_partially, action_type: "rejected_partially" },
            { label: "Rejected Completely", key: "rejected_completely", value: expenseReportData?.rejected_completely, action_type: "rejected_completely" }
          ], expenseReportLoading, expenseReportError)}
        </div>
      </div>
    </div>
  );
};

const styles = {
  sectionCard: {
    flex: "1 1 calc(25% - 20px)",
    backgroundColor: "#fff",
    borderRadius: "5px",
    padding: "15px",
    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
    flexWrap: 'wrap',
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "400",
    marginBottom: "10px",
    color: '#060606',
    marginTop: '0px',
    fontFamily: 'Roboto Slab',

  },
  sectionItem: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "5px",
    padding: '20px 10px',
    fontSize: '14px',
    color: '#505470',
    fontWeight: '400',
  },
  itemValue: {
    fontWeight: "700",
    color: "#5A55D2",
    fontSize: '16px',
  }
};

export default AccountDashboardReportScreen;